import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import AnalyticsTracker from "./components/AnalyticsTracker";
import CookiePolicy from "./pages/CookiePolicy";

// ===== Global Components =====
import Header from "./components/Header";
import Footer from "./components/Footer";

// ===== Pages =====
import Home from "./pages/Home";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import WhyVerify from "./pages/why-verify";
import VerifyEmail from "./pages/VerifyEmail";
import VerifyLicence from "./pages/VerifyLicence";
import Dashboard from "./pages/Dashboard";
import Listings from "./pages/Listings";
import MyListings from "./pages/MyListings.jsx";
import ListingsHandover from "./pages/ListingsHandover";
import MyPurchases from "./pages/MyPurchases";
import MySold from "./pages/MySold";
import ListingDetails from "./pages/ListingDetails";
import PostListing from "./pages/PostListing";
import EditListing from "./pages/EditListing";
import PurchaseSuccess from "./pages/PurchaseSuccess";
import PurchaseCancelled from "./pages/PurchaseCancelled";
import Profile from "./pages/Profile";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SelectCategory from "./pages/SelectCategory";
import SelectType from "./pages/SelectType";
import Checkout from "./pages/Checkout";
import Legal from "./pages/Legal";
import StripeOnboardingComplete from "./pages/StripeOnboardingComplete";
import ConnectStripe from "./pages/ConnectStripe";
import BusinessListings from "./pages/LawnMowing/Businesses/BusinessListings.jsx";
import BusinessDetails from "./pages/LawnMowing/Businesses/BusinessDetails.jsx";
import RoundsListings from "./pages/LawnMowing/Rounds/RoundsListings.jsx";
import RoundDetails from "./pages/LawnMowing/Rounds/RoundDetails.jsx";
import FranchiseListings from "./pages/LawnMowing/Franchises/FranchiseListings";
import FranchiseDetails from "./pages/LawnMowing/Franchises/FranchiseDetails";
import PostRound from "./pages/LawnMowing/Rounds/PostRound";
import PostBusiness from "./pages/LawnMowing/Businesses/PostBusiness";
import PostFranchise from "./pages/LawnMowing/Franchises/PostFranchise";
import BusinessSuccess from "./pages/LawnMowing/Businesses/BusinessSuccess";
import FranchiseSuccess from "./pages/LawnMowing/Franchises/FranchiseSuccess";
import RoundSuccess from "./pages/LawnMowing/Rounds/RoundSuccess";
import ListingActivationSuccess from "./pages/ListingActivationSuccess";
import EditRound from "./pages/LawnMowing/Rounds/EditRound";
import EditBusiness from "./pages/LawnMowing/Businesses/EditBusiness";
import EditFranchise from "./pages/LawnMowing/Franchises/EditFranchise";
import CleaningListings from "./pages/Cleaning/Listings/CleaningListings";
import CleaningDetails from "./pages/Cleaning/Listings/CleaningDetails";
import PostCleaningListing from "./pages/Cleaning/Listings/PostCleaningListing";
import CleaningPurchaseSuccess from "./pages/Cleaning/Listings/CleaningPurchaseSuccess";
import CleaningListingActivationSuccess from "./pages/Cleaning/Listings/CleaningListingActivationSuccess";
import EditCleaningListings from "./pages/Cleaning/Listings/EditCleaningListings";
import CleaningSwapListings from "./pages/Cleaning/Swaps/CleaningSwapListings";
import CleaningSwapDetails from "./pages/Cleaning/Swaps/CleaningSwapDetails";
import RequestCleaningSwap from "./pages/Cleaning/Swaps/RequestCleaningSwap";
import PostCleaningSwapListings from "./pages/Cleaning/Swaps/PostCleaningSwapListings";
import CleaningSwapDeal from "./pages/Cleaning/Swaps/CleaningSwapDeal";
import CleaningSwapPayment from "./pages/Cleaning/Swaps/CleaningSwapPayment";
import CleaningSwapPaymentSuccess from "./pages/Cleaning/Swaps/CleaningSwapPaymentSuccess";
import RequestMowingSwap from "./pages/RequestMowingSwap";
import EditCleaningSwapListing from "./pages/Cleaning/Swaps/EditCleaningSwapListing";
import PoolCareListings from "./pages/PoolCare/Listings/PoolCareListings";
import PoolCareDetails from "./pages/PoolCare/Listings/PoolCareDetails";
import PostPoolCareListing from "./pages/PoolCare/Listings/PostPoolCareListing";
import EditPoolCareListings from "./pages/PoolCare/Listings/EditPoolCareListings";
import PoolCareListingActivationSuccess from "./pages/PoolCare/Listings/PoolCareListingActivationSuccess";
import PoolCarePurchaseSuccess from "./pages/PoolCare/Listings/PoolCarePurchaseSuccess";
import PoolCareSwapListings from "./pages/PoolCare/Swaps/PoolCareSwapListings";
import PoolCareSwapDetails from "./pages/PoolCare/Swaps/PoolCareSwapDetails";
import RequestPoolCareSwap from "./pages/PoolCare/Swaps/RequestPoolCareSwap";
import PostPoolCareSwapListings from "./pages/PoolCare/Swaps/PostPoolCareSwapListings";
import PoolCareSwapDeal from "./pages/PoolCare/Swaps/PoolCareSwapDeal";
import PoolCareSwapPaymentSuccess from "./pages/PoolCare/Swaps/PoolCareSwapPaymentSuccess";
import PoolCareSwapListingSuccess from "./pages/PoolCare/Swaps/PoolCareSwapListingSuccess";
import EditPoolCareSwapListing from "./pages/PoolCare/Swaps/EditPoolCareSwapListing";
import LawnMowingHub from "./pages/Browse/LawnMowingHub";
import CleaningHub from "./pages/Browse/CleaningHub";
import PoolCareHub from "./pages/Browse/PoolCareHub";
import SearchResults from "./pages/SearchResults";
import ClientExchangePlus from "./pages/ClientExchangePlus";
import ProtectedRoute from "./pages/ProtectedRoute";
import Support from "./pages/Support";
import ClientTransferGuidelines from "./pages/ClientTransferGuidelines";
import TermsOfUse from "./pages/TermsOfUse";
import SwapListingSuccess from "./pages/SwapListingSuccess";
import CleaningSwapListingSuccess from "./pages/Cleaning/Swaps/CleaningSwapListingSuccess";
import Contact from "./pages/Contact";
import PromotionActivationSuccess from "./pages/PromotionActivationSuccess";






// CLEANING ROUNDS
import CleaningRoundsListings from "./pages/Cleaning/Rounds/CleaningRoundsListings";
import PostCleaningRound from "./pages/Cleaning/Rounds/PostCleaningRound";
import CleaningRoundDetails from "./pages/Cleaning/Rounds/CleaningRoundDetails";
import EditCleaningRound from "./pages/Cleaning/Rounds/EditCleaningRound";
import CleaningRoundSuccess from "./pages/Cleaning/Rounds/CleaningRoundSuccess";

// CLEANING BUSINESS FOR SALE 
// ===== Cleaning Businesses =====
import CleaningBusinessListings from "./pages/Cleaning/Businesses/CleaningBusinessListings";
import PostCleaningBusiness from "./pages/Cleaning/Businesses/PostCleaningBusiness";
import CleaningBusinessDetails from "./pages/Cleaning/Businesses/CleaningBusinessDetails";
import EditCleaningBusiness from "./pages/Cleaning/Businesses/EditCleaningBusiness";
import CleaningBusinessSuccess from "./pages/Cleaning/Businesses/CleaningBusinessSuccess";

// CLEANING FRANCHISES FOR SALE 
import CleaningFranchiseListings from "./pages/Cleaning/franchises/CleaningFranchiseListings";
import PostCleaningFranchise from "./pages/Cleaning/franchises/PostCleaningFranchise";
import CleaningFranchiseDetails from "./pages/Cleaning/franchises/CleaningFranchiseDetails";
import EditCleaningFranchise from "./pages/Cleaning/franchises/EditCleaningFranchise";
import CleaningFranchiseSuccess from "./pages/Cleaning/franchises/CleaningFranchiseSuccess";

//POOL CARE BUSINESS & FRANCHISE
import PostPoolCareBusinessFranchise from "./pages/PoolCare/Business/PostPoolCareBusinessFranchise";
import PoolCareBusinessFranchiseSuccess from "./pages/PoolCare/Business/PoolCareBusinessFranchiseSuccess";
import PoolCareBusinessFranchiseListings from "./pages/PoolCare/Business/PoolCareBusinessFranchiseListings";
import PoolCareBusinessFranchiseDetails from "./pages/PoolCare/Business/PoolCareBusinessFranchiseDetails";
import EditPoolCareBusinessFranchise from "./pages/PoolCare/Business/EditPoolCareBusinessFranchise";



// ===== Swap Pages =====
import SwapListings from "./pages/SwapListings";
import SwapDetails from "./pages/SwapDetails";
import PostSwapListing from "./pages/PostSwapListing";
import MySwapOffers from "./pages/MySwapOffers";
import SwapInbox from "./pages/SwapInbox";
import SwapDeal from "./pages/SwapDeal";
import MySwapDeals from "./pages/MySwapDeals";
import SwapPaymentSuccess from "./pages/SwapPaymentSuccess";
import SwapInvoice from "./pages/SwapInvoice";
import EditSwapListing from "./pages/EditSwapListing";
import Blog from "./pages/Blog";
import WhyContractorsBuySellSwap from "./pages/blog/WhyContractorsBuySellSwap";
import RecurringResidentialClientsValue from "./pages/blog/RecurringResidentialClientsValue";
import TheHiddenCostOfDrivingAcrossTownForRecurringVisits from "./pages/blog/TheHiddenCostOfDrivingAcrossTownForRecurringVisits";
import SpringTightenMowingRun from "./pages/blog/SpringTightenMowingRun";


 
// ===== Founder Page =====
import FounderStory from "./pages/FounderStory";

// ===== Admin =====
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import AdminConsole from "./pages/AdminConsole";

import SupportChat from "./components/SupportChat";


function App() {

  

  return (
    <Router>
      <AnalyticsTracker />
    <ScrollToTop />
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Header />

<div style={{ paddingTop: "52px", flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/why-verify" element={<WhyVerify />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/verify-licence" element={<VerifyLicence />} />
            <Route path="/support" element={<Support />} />
            <Route path="/blog" element={<Blog />} />

<Route
  path="/blog/why-contractors-buy-sell-swap-residential-clients"
  element={<WhyContractorsBuySellSwap />}
  
/>

<Route
  path="/blog/how-recurring-residential-clients-build-business-value"
  element={<RecurringResidentialClientsValue />}
/>

<Route
  path="/blog/the-hidden-cost-of-driving-across-town-for-recurring-visits"
  element={<TheHiddenCostOfDrivingAcrossTownForRecurringVisits />}
/>

<Route
  path="/blog/spring-tighten-your-mowing-run"
  element={<SpringTightenMowingRun />}
/>

           <Route
  path="/contact"
  element={
    <ProtectedRoute>
      <Contact />
    </ProtectedRoute>
  }
/>
            <Route
  path="/client-transfer-guidelines"
  element={<ClientTransferGuidelines />}
/>
<Route path="/terms" element={<TermsOfUse />} />
<Route path="/cookie-policy" element={<CookiePolicy />} />


           <Route
  path="/dashboard"
  element={
    <ProtectedRoute>
      <Dashboard />
    </ProtectedRoute>
  }
/>

            <Route path="/browse/lawn-mowing" element={<LawnMowingHub />} />
            <Route path="/browse/cleaning" element={<CleaningHub />} />
            <Route path="/browse/pool-care" element={<PoolCareHub />} />
            <Route path="/search" element={<SearchResults />} />
            <Route
  path="/plus"
  element={
    <ProtectedRoute>
      <ClientExchangePlus />
    </ProtectedRoute>
  }
/>


            {/* Listings */}
            <Route path="/listings" element={<Listings />} />
            <Route path="/listing/:id" element={<ListingDetails />} />
            <Route path="/post-listing" element={<PostListing />} />
            <Route path="/edit-listing/:id" element={<EditListing />} />
            <Route path="/my-listings" element={<MyListings />} />
            <Route path="/listings-handover/:saleId" element={<ListingsHandover />} />
            <Route path="/my-purchases" element={<MyPurchases />} />
            <Route path="/my-sold" element={<MySold />} />
            <Route path="/lawn-mowing/business" element={<BusinessListings />} />
            <Route path="/lawn-mowing/business/:id" element={<BusinessDetails />} />
            <Route path="/lawn-mowing/businesses/new" element={<PostBusiness />} />
            <Route path="/listing-activation-success" element={<ListingActivationSuccess />}/>
            <Route path="/promotion-activation-success" element={<PromotionActivationSuccess />} />
            <Route path="/edit-listing/:listingId" element={<EditListing />} />
            <Route path="/mowing/request-swap/:id" element={<RequestMowingSwap />}

/>


            {/* Cleaning – Client Listings */}
<Route path="/cleaning/listings" element={<CleaningListings />} />
<Route path="/cleaning/listing/:listingId" element={<CleaningDetails />} />
<Route path="/cleaning/post-listing" element={<PostCleaningListing />} />

{/* ✅ Cleaning swaps */}
<Route path="/cleaning/swaps" element={<CleaningSwapListings />} />
<Route path="/cleaning/swaps/:id" element={<CleaningSwapDetails />} />
<Route
  path="/cleaning/swaps/:id/request"
  element={<RequestCleaningSwap />}
/>
<Route
  path="/cleaning/swap-listing-success/:listingId"
  element={<CleaningSwapListingSuccess />}
/>
<Route
  path="/cleaning/post-swap"
  element={<PostCleaningSwapListings />}
/>

<Route
  path="/cleaning/swap-deal/:id"
  element={<CleaningSwapDeal />}
/>
<Route
  path="/cleaning/swaps/pay/:id"
  element={<CleaningSwapPayment />}
/>
<Route
  path="/cleaning/swap-payment-success/:dealId"
  element={<CleaningSwapPaymentSuccess />}
/>
<Route
  path="/cleaning/swaps/edit/:listingId"
  element={<EditCleaningSwapListing />}
/>


{/* Cleaning – Purchase Success */}
<Route
  path="/cleaning/purchase-success/:listingId"
  element={<CleaningPurchaseSuccess />}
/>
{/* Cleaning – Listing Success */}
<Route
  path="/cleaning/listing-activation-success/:listingId"
  element={<CleaningListingActivationSuccess />}
/>
<Route
  path="/cleaning/listings/edit/:id"
  element={<EditCleaningListings />}
/>

{/* PoolCare – Client Listings */}

<Route path="/poolcare/listings" element={<PoolCareListings />} />
<Route path="/poolcare/listing/:listingId" element={<PoolCareDetails />} />
<Route path="/poolcare/post" element={<PostPoolCareListing />} />
<Route path="/poolcare/listings/edit/:id" element={<EditPoolCareListings />} />

<Route
  path="/poolcare/listing-activation-success"
  element={<PoolCareListingActivationSuccess />}
/>

<Route path="/poolcare/purchase-success/:listingId" element={<PoolCarePurchaseSuccess />}
/>

{/* PoolCare  – SWAP Listings */}
<Route
  path="/poolcare/swaps"
  element={<PoolCareSwapListings />}
/>
<Route
  path="/poolcare/swaps/:listingId"
  element={<PoolCareSwapDetails />}
/>
<Route
  path="/poolcare/swaps/request/:id"
  element={<RequestPoolCareSwap />}
/>

<Route
  path="/poolcare/swaps/post"
  element={<PostPoolCareSwapListings />}
/>
<Route
  path="/poolcare/swaps/deal/:dealId"
  element={<PoolCareSwapDeal />}
/>

<Route
  path="/poolcare/swap-payment-success/:dealId"
  element={<PoolCareSwapPaymentSuccess />}
/>
<Route
  path="/poolcare/swap-listing-success/:listingId"
  element={<PoolCareSwapListingSuccess />}
/>
<Route
  path="/poolcare/swaps/edit/:listingId"
  element={<EditPoolCareSwapListing />}
/>


           
            {/* Lawn Mowing — Rounds */}
            <Route path="/lawn-mowing/rounds/success" element={<RoundSuccess />} />
            <Route path="/lawn-mowing/rounds/new" element={<PostRound />} />
            <Route path="/lawn-mowing/rounds" element={<RoundsListings />} />
            <Route path="/lawn-mowing/rounds/:id" element={<RoundDetails />} />
            <Route path="/lawn-mowing/rounds/edit/:id" element={<EditRound />}
/>

<Route path="/lawn-mowing/franchise" element={<FranchiseListings />} />
<Route path="/lawn-mowing/franchise/:id" element={<FranchiseDetails />} />
<Route path="/lawn-mowing/franchises/new" element={<PostFranchise />} />

{/* ===========================
    CLEANING ROUNDS
=========================== */}
<Route path="/cleaning/rounds" element={<CleaningRoundsListings />} />
<Route path="/cleaning/rounds/new" element={<PostCleaningRound />} />
<Route path="/cleaning/rounds/:id" element={<CleaningRoundDetails />} />
<Route path="/cleaning/rounds/edit/:id" element={<EditCleaningRound />} />
<Route path="/cleaning/rounds/success" element={<CleaningRoundSuccess />} />

{/* ===========================
    CLEANING BUSINESS FOR SALE 
=========================== */}
<Route path="/cleaning/business" element={<CleaningBusinessListings />} />
<Route path="/cleaning/business/new" element={<PostCleaningBusiness />} />
<Route path="/cleaning/business/:id" element={<CleaningBusinessDetails />} />
<Route path="/cleaning/business/edit/:id" element={<EditCleaningBusiness />} />
<Route path="/cleaning/business/success" element={<CleaningBusinessSuccess />} />

{/* ===========================
    CLEANING FRANCHISES FOR SALE 
=========================== */}

<Route path="/cleaning/franchises" element={<CleaningFranchiseListings />} />
<Route path="/cleaning/franchises/post" element={<PostCleaningFranchise />} />
<Route path="/cleaning/franchises/:id" element={<CleaningFranchiseDetails />} />
<Route path="/cleaning/franchises/edit/:id" element={<EditCleaningFranchise />} />
<Route path="/cleaning/franchises/success" element={<CleaningFranchiseSuccess />} />


{/* ===========================
    POOL CARE BUSINESS  FOR SALE 
=========================== */}

<Route path="/poolcare/businesses/create" element={<PostPoolCareBusinessFranchise />} />
<Route path="/poolcare/businesses/:id" element={<PoolCareBusinessFranchiseDetails />} />
<Route path="/poolcare/businesses/success" element={<PoolCareBusinessFranchiseSuccess />} />
<Route path="/poolcare/businesses" element={<PoolCareBusinessFranchiseListings />} />
<Route path="/poolcare/businesses/edit/:id" element={<EditPoolCareBusinessFranchise />} />



{/* Lawn Mowing — Business */}
<Route
  path="/lawn-mowing/business/success"
  element={<BusinessSuccess />}
/>
<Route
  path="/lawn-mowing/business/edit/:id"
  element={<EditBusiness />}
/>


{/* Lawn Mowing — Franchise */}
<Route
  path="/lawn-mowing/franchises/success"
  element={<FranchiseSuccess />}
  
/>
<Route path="/lawn-mowing/franchises/:id" element={<FranchiseDetails />} />
<Route
  path="/lawn-mowing/franchises/:id"
  element={<FranchiseDetails />}
/>

<Route
  path="/lawn-mowing/franchises/edit/:id"
  element={<EditFranchise />}
/>



            {/* Mowing Swap System */}
            <Route path="/swaps" element={<SwapListings />} />
            <Route path="/post-swap" element={<PostSwapListing />} />
            <Route path="/swap/:id" element={<SwapDetails />} />
            <Route path="/swap-deal/:dealId" element={<SwapDeal />} />  {/* ⭐ CORRECT ⭐ */}
            <Route path="/swap-details/:listingId" element={<SwapDetails />} /> 
            <Route path="/swaps/edit/:id" element={<EditSwapListing />} />


            
            {/* Mowing Swap Pages */}
            <Route path="/my-swap-offers" element={<MySwapOffers />} />
            <Route path="/swap-inbox" element={<SwapInbox />} />
            <Route path="/my-swap-deals" element={<MySwapDeals />} />
            <Route path="/swap-invoice/:swapRef" element={<SwapInvoice />} />
            <Route path="/swap-listing-success/:listingId" element={<SwapListingSuccess />}
/>



            {/* Checkout / Payment */}
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/purchase-success/:transactionRef" element={<PurchaseSuccess />} />
            <Route path="/purchase-cancelled" element={<PurchaseCancelled />} />
            <Route path="/swap-payment-success/:dealId" element={<SwapPaymentSuccess />}
/>

            <Route path="/stripe-complete" element={<StripeOnboardingComplete />} />




            {/* User */}
            <Route path="/profile" element={<Profile />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/select-category" element={<SelectCategory />} />
            <Route path="/select-type/:category" element={<SelectType />} />
            <Route path="/connect-stripe" element={<ConnectStripe />} />


            {/* Legal */}
            <Route path="/legal" element={<Legal />} />

            {/* Founder Page */}
            <Route path="/founder" element={<FounderStory />} />

            {/* Admin */}
            <Route
              path="/admin-console"
              element={
                <ProtectedAdminRoute>
                  <AdminConsole />
                </ProtectedAdminRoute>
              }
            />
          </Routes>
        </div>
<SupportChat />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
